<template>
  <transition name="ee-fade">
    <div v-if="lastUnreadInPageMessage" class="ee-inpage" role="status" @click="clicked">
      <span class="ee-inpage__ic material-symbols-outlined">campaign</span>
      <div class="ee-inpage__text ee-prose" v-html="lastUnreadInPageMessage.text" />
      <button type="button" class="ee-inpage__ok" @click.stop="markAsRead">{{ tm('got_it', 'Got it') }}</button>
    </div>
  </transition>
</template>

<script>
import InPageMessages from '../in-page-messages.vue'
import i18nMixin from '../../modern/i18n'

// Announcement shown on top of every page until confirmed (news marked "in page"); logic of the classic banner.
export default {
  extends: InPageMessages,

  mixins: [i18nMixin],
}
</script>
